import './buttons.css'

const Social = ({link, icon, text}) => {

      if(link === '') return 

      return (
            <a href={link} className="btn_social" target="_blank" rel="noreferrer">
                  {icon}
                  <span>{text}</span>
            </a>
      )
}

export default Social
